import { Injectable } from "@angular/core";
import { BaseState } from "@webapp/core/abstracts/services/base-state.service";

@Injectable()
export class AutoFieldsState extends BaseState {}
